import { useContext } from 'react';

import { ReckonOneUIPreferencesContext } from './ReckonOneUIPreferencesContext';

/**
 * For UI that also renders outside the provider — e.g. the app layout on
 * non-secure routes like `/v2/404`, where no book is loaded. Returns `null`
 * there instead of throwing.
 */
export const useOptionalReckonOneUIPreferences = () => {
  return useContext(ReckonOneUIPreferencesContext);
};

export const useReckonOneUIPreferences = () => {
  const context = useOptionalReckonOneUIPreferences();
  if (!context) {
    throw new Error(
      'useReckonOneUIPreferences must only be used within <ReckonOneUIPreferencesProvider>'
    );
  }

  return context;
};
